import { Injectable } from "@angular/core";
import { TCIAppStatusCategory, ITCIApplicationDeployResponse, ITCIApplicationDeployRequest } from "@tci/common";
import { Subject } from "rxjs";
import * as LRUCache from "lru-cache";

@Injectable()
export class NgAppDeployService {
    private static instance: NgAppDeployService = null;

    private closeMiniDetails$: Subject<string> = new Subject();

    private dialogConfirmationRequest$: Subject<ITCIApplicationDeployRequest> = new Subject();
    private dialogConfirmationResponse$: Subject<ITCIApplicationDeployResponse> = new Subject();

    /**
     * Last status cache per app
     */
    private lastStates = new LRUCache({ max: 500 });

    public static getInstance() {
        if (!NgAppDeployService.instance) {
            NgAppDeployService.instance = new NgAppDeployService();
        }
        return NgAppDeployService.instance;
    }

    getCloseMiniDetailsSubj() {
        return this.closeMiniDetails$;
    }

    closeMiniDetails(appId: string) {
        this.closeMiniDetails$.next(appId);
    }

    setLastState(appId: string, label: string, category: TCIAppStatusCategory) {
        this.lastStates.set(appId, { label, category });
    }

    getLastState(appId: string): { label: string, category: TCIAppStatusCategory } {
        return this.lastStates.get(appId);
    }

    // Dialogs
    getDialogRequestSubj() {
        return this.dialogConfirmationRequest$;
    }

    getDialogResponseSubj() {
        return this.dialogConfirmationResponse$;
    }

    dialogOpenRequest(request: ITCIApplicationDeployRequest) {
        return this.dialogConfirmationRequest$.next(request);
    }

    setDialogResponse(response: ITCIApplicationDeployResponse) {
        this.dialogConfirmationResponse$.next(response);
    }
}
